import FocusTrap from '../klaro/focus-trap';
//Search functionality
let searchTemplate = '';
let templateTemplate = '';
let focusTrap = new FocusTrap(document.getElementById('search-container'));

// Initialize when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
    // Get the template HTML from the #searchTemplate element
    searchTemplate = document.getElementById('searchTemplate').innerHTML;
    // Compile the Handlebars template
    templateTemplate = Handlebars.compile(searchTemplate);
});

// Search button open
document.querySelectorAll('button.search').forEach(button => {
    button.addEventListener('click', function () {
        document.getElementById('search').classList.add('open');
        document.body.style.overflow = 'hidden';
        document.getElementById('search-form-content-input').focus();
        focusTrap.activate();
    });
});

// Search button close
document.getElementById('closeSearch').addEventListener('click', function() {
    document.getElementById('search').classList.remove('open');
    document.body.style.overflow = 'auto';
});

// Handle form submission for #searchForm
document.getElementById('searchForm').addEventListener('submit', function (e) {
    e.preventDefault();

    // Gather form data
    const formMethod = this.getAttribute('method');
    const formAction = this.getAttribute('action');
    const formData = new FormData(this);

    // Perform AJAX request
    fetch(formAction, {
        method: formMethod,
        body: new URLSearchParams(formData) // Convert FormData to URL-encoded string
    })
        .then(response => response.json())
        .then(result => {
            const searchData = templateTemplate(result);
            document.getElementById('searchresults').innerHTML = searchData;
            focusTrap.refresh();
        })
        .catch(error => console.error('Error:', error));
});